import { initFederation } from '@angular-architects/native-federation';

if (typeof (globalThis as { ngDevMode?: boolean }).ngDevMode === 'undefined') {
  (globalThis as { ngDevMode?: boolean }).ngDevMode = false;
}

// Only the host's own (same-origin) manifest is needed before the shell can start.
// Remotes such as ai_ui are registered lazily by AiStudioRemoteService on first
// use (and warmed on idle), so their manifest fetch no longer delays first paint.
initFederation()
  .catch((err) => console.error(err))
  .then(() => import('./bootstrap'))
  .catch((err) => console.error(err));

